<div class="ai-page">
  <div class="ai-card">

    <div class="ai-loading" *ngIf="loading">
      <mat-spinner diameter="28"></mat-spinner>
    </div>

    <ng-container *ngIf="!loading">

      <!-- needs a session first -->
      <ng-container *ngIf="!signedIn && !error">
        <h2>Sign in to see this invitation</h2>
        <p>
          An invitation can only be accepted by the person it was addressed to, so we need to know
          who you are first.
        </p>
        <button mat-raised-button color="primary" class="btn-send clr-white" (click)="signIn()">
          Sign in
        </button>
        <p class="ai-sub">
          After signing in you will find it waiting under Shared workspaces &mdash; you do not need
          this link again.
        </p>
      </ng-container>

      <!-- not valid for this account -->
      <ng-container *ngIf="error">
        <h2>This invitation is not available</h2>
        <p>{{ error }}</p>
        <p class="ai-sub">
          It may have been withdrawn, already used, expired, or sent to a different address than the
          one you are signed in with.
        </p>
        <button mat-button class="routeClr" [routerLink]="['/shared-workspaces']">
          Go to shared workspaces
        </button>
      </ng-container>

      <!-- the invitation -->
      <ng-container *ngIf="invite && !error">
        <h2>{{ invite.invitedBy }} invited you to {{ invite.workspaceName }}</h2>
        <p>
          A shared workspace is where someone publishes memories and recipes for other people to use.
        </p>
        <p>
          You will be able to <strong>read what is shared there</strong>. You cannot change it, and
          nothing of your own becomes visible to anyone else.
        </p>

        <div class="ai-actions" *ngIf="invite.status === 'PENDING'">
          <button mat-raised-button color="primary" class="btn-send clr-white"
            (click)="accept()" [disabled]="busy">Accept invitation</button>
          <button mat-button (click)="decline()" [disabled]="busy">Decline</button>
        </div>

        <p class="ai-sub" *ngIf="invite.status !== 'PENDING'">
          This invitation is {{ invite.status | lowercase }} and can no longer be used.
        </p>
      </ng-container>

    </ng-container>

  </div>
</div>
